import { render, staticRenderFns } from "./CollapseReservaLegal.vue?vue&type=template&id=0400519c&lang=pug"
import script from "./CollapseReservaLegal.vue?vue&type=script&lang=js"
export * from "./CollapseReservaLegal.vue?vue&type=script&lang=js"
import style0 from "./CollapseReservaLegal.vue?vue&type=style&index=0&id=0400519c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports